import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { JobPointeTransferService } from '../job-pointe-transfer.service';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-manage-owner',
  templateUrl: './manage-owner.component.html',
  styleUrls: ['./manage-owner.component.scss'],
})
export class ManageOwnerComponent implements OnInit {
  isManageOwnerModalOpen: boolean = false;
  modalSubscription: Subscription;
  rowSubscription: Subscription;
  manageOwnerDetailForm: FormGroup;
  selectedRow: any = {};
  isActiveWorkingStatus = false;
  jobBoardAttributes: Array<any> = [];
  empJobBoardAttributes: Array<any> = [];

  private renderer2: Renderer2;
  @Inject(DOCUMENT) private _document;

  constructor(
    private jobPointeTransferService: JobPointeTransferService,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.modalSubscription = this.jobPointeTransferService.isManageOwnerModalOpen.subscribe(value => {
      if (!value) return;
      this.selectedRow = JSON.parse(JSON.stringify(value));
      this.isManageOwnerModalOpen = true;
    });
  }

  get jobBoardAttributesFormArray(): FormArray {
    return this.manageOwnerDetailForm.get('job_board_attributes') as FormArray;
  }

  setJobBoardAttribute(attribute, field, value) {
    let index = this.getAttributeIndex(attribute);
    this.jobBoardAttributesFormArray.at(index).patchValue({ [field]: value });
  }

  getAttributeIndex(attribute) {
    return this.jobBoardAttributesFormArray.value.indexOf(attribute.value);
  }

  setDataToControl(field, value) {
    this.manageOwnerDetailForm.get(field).setValue(value);
  }

  createManageOwnerDetailForm(data) {
    this.manageOwnerDetailForm = this.formBuilder.group({});
  }

  handleClose() {
    this.isManageOwnerModalOpen = false;
  }

  loadDatePicker(className = null, altField = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    if (className != null) {
      s.text = `loadDatePicker('` + className + `','` + altField + `');`;
    } else {
      s.text = `loadDatePicker()`;
    }
    this.renderer2.appendChild(this._document.body, s);
  }
}
